import React from "react";
import ContentToday from "../components/pages/Dashboard/ContentToday";
import SideNav from "../components/SideNav/sideNav";
import Header from "../components/Header/hearder";
import { Wrapper } from "./layout.styles";

const ContentTodayLayout = () => {
  return (
    <React.Fragment>
      <Header />
      <Wrapper>
        <SideNav />
        <div style={{ margin: "70px 0px 0px 200px", width: "100%" }}>
          <ContentToday />
        </div>
      </Wrapper>
    </React.Fragment>
  );
};

export default ContentTodayLayout;
